// extracted by mini-css-extract-plugin
export default {"slideContainer":"tipsSlide_slideContainer__Lrkkc","slideContent":"tipsSlide_slideContent__b2yas"};